export default {"src":"/_next/static/image/public/images/ic_dropdown_arrow.30f95583c5986db0589dc910400236f1.svg","height":8,"width":12};